import INITIAL_STATE from "./initial-state";
import { TYPES } from "../actions/review-short-actions";

const reviewShortReducer = (state = INITIAL_STATE.reviewShort, action) => {
  switch (action.type) {
    case TYPES.OPEN_REVIEW_SHORT_OFFCANVAS: {
      return {
        open: true,
        closet: action.closet,
        finished: false,
      };
    }

    case TYPES.CLOSE_REVIEW_SHORT_OFFCANVAS: {
      return {
        open: false,
        closet: {},
        finished: false,
      };
    }

    case TYPES.MOVE_TO_NEXT_CLOSET_ITEM_REVIEW: {
      const updatedClosetItems = state.closet.closet_items.filter(
        (closetItem) =>
          closetItem.id !== action.closetItem.id && !closetItem.review?.short_review_done,
      );
      const closetItemsToReview = updatedClosetItems.filter(
        (closetItem) => closetItem.product.family !== "accessory",
      );

      return {
        ...state,
        closet: {
          ...state.closet,
          closet_items: updatedClosetItems,
        },
        finished: !closetItemsToReview.length,
      };
    }

    default:
      return state;
  }
};

export default reviewShortReducer;
